import { HIGHEST_OI_GAINERS_LOSERS, HIGHEST_OI_GAINERS_LOSERS_STREAM, HIGHEST_OI_LAST_UPDATED_TIME, } from "../../../interface/DrivingMarket/iHighestOIGainersLosers";
import { drivingMarketStream } from "@domains/features/Markets/Futures/utils/streamingUpdate";
let initState = {
    latestUpdatedTime: "",
    highOIGainersLosers: [],
};
const highestOIGainersLosersReducer = (state = initState, action) => {
    var _a;
    switch (action.type) {
        case HIGHEST_OI_GAINERS_LOSERS:
            return Object.assign(Object.assign({}, state), { highOIGainersLosers: action.payload.highOIGainersLosers });
        case HIGHEST_OI_GAINERS_LOSERS_STREAM:
            return Object.assign(Object.assign({}, state), { highOIGainersLosers: drivingMarketStream(state.highOIGainersLosers, action.payload.qouteStream), latestUpdatedTime: (_a = action.payload.qouteStream) === null || _a === void 0 ? void 0 : _a.updatedTime });
        case HIGHEST_OI_LAST_UPDATED_TIME:
            return Object.assign(Object.assign({}, state), { latestUpdatedTime: action.payload.latestUpdatedTime });
        default:
            return state;
    }
};
export default highestOIGainersLosersReducer;
